// extracted by mini-css-extract-plugin
export default {"layer":"Home_layer__Q1phg","active":"Home_active__wx75c","animated":"Home_animated__OYEN1","fade-out":"Home_fade-out__NItT-"};